// extracted by mini-css-extract-plugin
export default {"header":"flightSummary-module__header__E1jD+","priceDetails":"flightSummary-module__priceDetails__kZERk"};